import { Button, DialogActions } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import './CancelDialog.css'
import { onClickConfirmCancelProject } from './handler/ProjectManagementHandler';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function CancelDialogProjectManagement({argsAll }) {
    // Re-render when the translation dictionary loads/updates.
    useTranslationSubscription();

    const onCloseDialogReject = (event, reason) => {
        argsAll.setOpenCancelDialog(false);
    };

    return (
        <Dialog
            open={argsAll.openCancelDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirmPlease">{trI18n('USER12MSG010')}</div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    onClick={() => onClickConfirmCancelProject(argsAll)}
                    variant="contained"
                    className="btn-hg32 btn-handle-delete-user-agree"
                >
                    {trI18n('COMBTN002')}
                </Button>

                <Button
                    variant="contained"
                    className="btn-light btn-hg32"
                    onClick={onCloseDialogReject}
                >
                    {trI18n('COMBTN007')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
